"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContextualHelp = ContextualHelp;
exports.ContextualHelpFromPath = ContextualHelpFromPath;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _grommet = require("grommet");
var _reactI18next = require("react-i18next");
var _i18n = _interopRequireDefault(require("./i18n"));
var _HelpContext = require("./HelpContext");
var _ContextualHelpPanel = require("./components/ContextualHelpPanel");
var _ModalDialog = require("./components/ModalDialog");
var _qualtrics = require("./api/qualtrics");
var _ContextualHelpData = require("./ContextualHelpData");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["topicsId", "hideTopicUrl", "viewAllUrl", "surveyId", "qualtricsToken", "onFeedback", "onClose", "pinnable"],
  _excluded2 = ["locale", "proxy", "topicsId", "hideTopicUrl", "viewTopicPrefix", "viewAllUrl", "surveyId", "qualtricsToken", "onFeedback", "onClose", "pinnable"],
  _excluded3 = ["locale", "proxy", "onLocationChange", "hideTopicUrl", "viewAllUrl", "viewTopicPrefix", "surveyId", "qualtricsToken", "onFeedback", "pinnable"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var smallScreenSizes = ['xsmall', 'small'];
function HelpContainer(_ref) {
  var topicsId = _ref.topicsId,
    _ref$hideTopicUrl = _ref.hideTopicUrl,
    hideTopicUrl = _ref$hideTopicUrl === void 0 ? false : _ref$hideTopicUrl,
    viewAllUrl = _ref.viewAllUrl,
    surveyId = _ref.surveyId,
    qualtricsToken = _ref.qualtricsToken,
    onFeedbackProp = _ref.onFeedback,
    onCloseProp = _ref.onClose,
    _ref$pinnable = _ref.pinnable,
    pinnable = _ref$pinnable === void 0 ? true : _ref$pinnable,
    rest = _objectWithoutProperties(_ref, _excluded);
  var size = (0, _react.useContext)(_grommet.ResponsiveContext);
  var _useHelpContext = (0, _HelpContext.useHelpContext)(),
    isHelpOpen = _useHelpContext.isHelpOpen,
    setHelpOpen = _useHelpContext.setHelpOpen,
    topics = _useHelpContext.topics,
    setTopicsId = _useHelpContext.setTopicsId,
    setActiveTopicId = _useHelpContext.setActiveTopicId,
    activeTopicContent = _useHelpContext.activeTopicContent,
    activeTopicUrl = _useHelpContext.activeTopicUrl,
    activeTopicUrls = _useHelpContext.activeTopicUrls,
    addTopicUrl = _useHelpContext.addTopicUrl,
    loading = _useHelpContext.loading,
    locale = _useHelpContext.locale,
    proxy = _useHelpContext.proxy,
    error = _useHelpContext.error;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var isSmall = smallScreenSizes.includes(size);
  var width = isSmall ? undefined : '425px';
  var _useState = (0, _react.useState)(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    pinnedTopicsId = _useState2[0],
    setPinnedTopicsId = _useState2[1];

  // update class on body
  (0, _react.useEffect)(function () {
    var bodyClasses = document.body.className.split(' ');
    var hasHelpOpen = bodyClasses.includes('helpOpen');
    if (isHelpOpen) {
      if (!hasHelpOpen) {
        document.body.className = [].concat(_toConsumableArray(bodyClasses), ['helpOpen']).join(' ');
      }
    } else if (hasHelpOpen) {
      document.body.className = bodyClasses.filter(function (item) {
        return item !== 'helpOpen';
      });
    }
  }, [isHelpOpen]);
  (0, _react.useEffect)(function () {
    if (isHelpOpen) {
      setTopicsId(pinnedTopicsId || topicsId);
    }
  }, [isHelpOpen, topicsId, setTopicsId, pinnedTopicsId]);

  // TODO test undefined topics id
  // TODO setTopicsId to set single element in activeUrls
  var onContextHelp = (0, _react.useCallback)(function (ev) {
    var _ev$detail;
    // https://support.hpe.com/hpesc/public/api/document/pages/renderLatest?resourceId=glcp-dashboard-001&locale=en_US
    // const open = ev.detail?.open !== undefined ? ev.detail.open : !isHelpOpen
    var topic = (_ev$detail = ev.detail) === null || _ev$detail === void 0 ? void 0 : _ev$detail.topic;
    if (topic) {
      var _ev$detail2;
      addTopicUrl((0, _ContextualHelpData.resourceIdToUrl)(topic, locale, proxy), true);
      setHelpOpen(true);
      if ((_ev$detail2 = ev.detail) !== null && _ev$detail2 !== void 0 && _ev$detail2.pin) {
        setPinnedTopicsId(topicsId);
      }
    } else {
      setPinnedTopicsId(undefined);
      setHelpOpen(!isHelpOpen);
    }
  }, [addTopicUrl, isHelpOpen, setHelpOpen, topicsId]);

  // toggle help based on contextHelp event
  (0, _react.useEffect)(function () {
    window.addEventListener('contextHelp', onContextHelp);
    window.addEventListener('context-help', onContextHelp);
    return function () {
      window.removeEventListener('contextHelp', onContextHelp);
      window.removeEventListener('context-help', onContextHelp);
    };
  }, [onContextHelp]);
  var onClose = (0, _react.useCallback)(function () {
    if (onCloseProp) {
      onCloseProp();
    }
    setPinnedTopicsId(undefined);
    setHelpOpen(false);
  }, [onCloseProp, setHelpOpen]);
  var onFeedback;
  if (qualtricsToken || onFeedbackProp) {
    onFeedback = function onFeedback(value) {
      var _window, _window2;
      var requestBody = {
        values: {
          fullURL: (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.pathname,
          //
          QID1: value.rating === 'like' ? 1 : 2,
          // (numeric 1 or 2 for thumbs up/down
          QID2_TEXT: value.why || '',
          // Tell us why?
          QID3_TEXT: ((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.location) === null || _window2 === void 0 ? void 0 : _window2.pathname) || '',
          // overall page URL
          QID4_TEXT: activeTopicUrls[activeTopicUrls.length - 1] || '',
          // renderLatest
          QID5_TEXT: topicsId,
          // resourceId
          QID6_TEXT: '' // TBD
        }
      };
      return onFeedbackProp ? onFeedbackProp(requestBody) : (0, _qualtrics.sendSurveyResponse)(surveyId, qualtricsToken, requestBody);
    };
  }
  var onInternalLink = (0, _react.useCallback)(function (ev) {
    return addTopicUrl(ev.target.href);
  }, [addTopicUrl]);
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    imagePopup = _useState4[0],
    setImagePopup = _useState4[1];
  var onImageClick = function onImageClick(ev) {
    return !isSmall ? setImagePopup(ev.target) : undefined;
  };
  var onPin = function onPin(pinned) {
    setPinnedTopicsId(pinned ? topicsId : undefined);
  };
  var onBack = function onBack(resourceId) {
    // clear the pin if we're going back to topic list
    if (activeTopicUrls.length <= 2 && pinnedTopicsId) {
      setPinnedTopicsId(undefined);
    }
    setActiveTopicId(resourceId);
  };
  var l10n = function l10n(key, def) {
    return _i18n["default"].exists(key) ? t(key) : def;
  };
  return isHelpOpen ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ContextualHelpPanel.ContextualHelpPanel, _objectSpread({
      viewAllUrl: viewAllUrl,
      topics: topics,
      topic: activeTopicContent,
      topicUrl: hideTopicUrl ? undefined : activeTopicUrl,
      loading: !!(loading && topicsId),
      error: error,
      onBack: topics && activeTopicUrls.length > 0 ? onBack : undefined,
      onClose: onClose,
      onInternalLink: onInternalLink,
      onImageClick: onImageClick,
      onTopic: setActiveTopicId,
      onFeedback: onFeedback,
      pin: !!pinnedTopicsId,
      onPin: pinnable ? onPin : undefined,
      width: width,
      backLabel: activeTopicUrls.length > 1 ? l10n('back_middle_label', 'Previous topic') : undefined
    }, rest)), imagePopup && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalDialog.ModalDialog, {
      onClose: function onClose() {
        return setImagePopup(undefined);
      },
      testId: "contextual-help-".concat(imagePopup === null || imagePopup === void 0 ? void 0 : imagePopup.id),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.Image, {
        src: imagePopup === null || imagePopup === void 0 ? void 0 : imagePopup.src
      })
    })]
  }) : null;
}
HelpContainer.propTypes = {
  topicsId: _propTypes["default"].string,
  hideTopicUrl: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  viewAllUrl: _propTypes["default"].string,
  surveyId: _propTypes["default"].string,
  qualtricsToken: _propTypes["default"].string,
  onFeedback: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  pinnable: _propTypes["default"].bool
};
function ContextualHelp(_ref2) {
  var _ref2$locale = _ref2.locale,
    locale = _ref2$locale === void 0 ? 'en-US' : _ref2$locale,
    proxy = _ref2.proxy,
    topicsId = _ref2.topicsId,
    _ref2$hideTopicUrl = _ref2.hideTopicUrl,
    hideTopicUrl = _ref2$hideTopicUrl === void 0 ? false : _ref2$hideTopicUrl,
    viewTopicPrefix = _ref2.viewTopicPrefix,
    viewAllUrl = _ref2.viewAllUrl,
    surveyId = _ref2.surveyId,
    qualtricsToken = _ref2.qualtricsToken,
    onFeedback = _ref2.onFeedback,
    onClose = _ref2.onClose,
    _ref2$pinnable = _ref2.pinnable,
    pinnable = _ref2$pinnable === void 0 ? true : _ref2$pinnable,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  _i18n["default"].changeLanguage(locale);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactI18next.I18nextProvider, {
    i18n: _i18n["default"],
    defaultNS: "contextual_help",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_HelpContext.HelpProvider, {
      locale: locale,
      proxy: proxy,
      viewTopicPrefix: viewTopicPrefix,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(HelpContainer, _objectSpread({
        topicsId: topicsId,
        hideTopicUrl: hideTopicUrl,
        viewAllUrl: viewAllUrl,
        surveyId: surveyId,
        qualtricsToken: qualtricsToken,
        onFeedback: onFeedback,
        pinnable: pinnable,
        onClose: onClose
      }, rest))
    })
  });
}
ContextualHelp.propTypes = {
  locale: _propTypes["default"].string,
  proxy: _propTypes["default"].string,
  topicsId: _propTypes["default"].string,
  hideTopicUrl: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  viewTopicPrefix: _propTypes["default"].string,
  viewAllUrl: _propTypes["default"].string,
  surveyId: _propTypes["default"].string,
  qualtricsToken: _propTypes["default"].string,
  onFeedback: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  pinnable: _propTypes["default"].bool
};
function ContextualHelpFromPath(_ref3) {
  var _window3, _window4;
  var _ref3$locale = _ref3.locale,
    locale = _ref3$locale === void 0 ? 'en-US' : _ref3$locale,
    proxy = _ref3.proxy,
    _ref3$onLocationChang = _ref3.onLocationChange,
    onLocationChange = _ref3$onLocationChang === void 0 ? function () {} : _ref3$onLocationChang,
    _ref3$hideTopicUrl = _ref3.hideTopicUrl,
    hideTopicUrl = _ref3$hideTopicUrl === void 0 ? false : _ref3$hideTopicUrl,
    viewAllUrl = _ref3.viewAllUrl,
    viewTopicPrefix = _ref3.viewTopicPrefix,
    surveyId = _ref3.surveyId,
    qualtricsToken = _ref3.qualtricsToken,
    onFeedback = _ref3.onFeedback,
    _ref3$pinnable = _ref3.pinnable,
    pinnable = _ref3$pinnable === void 0 ? true : _ref3$pinnable,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  var lastPathRef = (0, _react.useRef)((_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.location) === null || _window3 === void 0 ? void 0 : _window3.pathname);
  var _useState5 = (0, _react.useState)((_window4 = window) === null || _window4 === void 0 || (_window4 = _window4.location) === null || _window4 === void 0 ? void 0 : _window4.pathname),
    _useState6 = _slicedToArray(_useState5, 2),
    path = _useState6[0],
    setPath = _useState6[1];

  // Track path changes by triggering off app changes.
  (0, _react.useEffect)(function () {
    var observer = new window.MutationObserver(function () {
      var _window5;
      var nextPath = (_window5 = window) === null || _window5 === void 0 || (_window5 = _window5.location) === null || _window5 === void 0 ? void 0 : _window5.pathname;
      if (lastPathRef.current !== nextPath) {
        lastPathRef.current = nextPath;
        setPath(nextPath);
      }
    });
    var root = document.getElementById('root');
    observer.observe(root || document, {
      subtree: true,
      childList: true
    });
    return function () {
      return observer === null || observer === void 0 ? void 0 : observer.disconnect();
    };
  }, []);
  var topicsId = onLocationChange(path);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ContextualHelp, _objectSpread({
    locale: locale,
    proxy: proxy,
    topicsId: topicsId,
    hideTopicUrl: hideTopicUrl,
    viewTopicPrefix: viewTopicPrefix,
    viewAllUrl: viewAllUrl,
    surveyId: surveyId,
    qualtricsToken: qualtricsToken,
    onFeedback: onFeedback,
    pinnable: pinnable
  }, rest));
}
ContextualHelpFromPath.propTypes = {
  locale: _propTypes["default"].string,
  proxy: _propTypes["default"].string,
  onLocationChange: _propTypes["default"].func,
  hideTopicUrl: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  viewTopicPrefix: _propTypes["default"].string,
  viewAllUrl: _propTypes["default"].string,
  surveyId: _propTypes["default"].string,
  qualtricsToken: _propTypes["default"].string,
  onFeedback: _propTypes["default"].func,
  pinnable: _propTypes["default"].bool
};